import { useAppSelector } from 'hooks';
import { selectCsatConfigRevamped } from 'reducers/config';
import { selectCsatStates, selectFeatureFlags } from 'reducers/workflows';
import { CsatSurveyContent } from './CsatSurveyContent';
import { CsatSurveySubmitted } from './CsatSurveySubmitted';
import { useContinueConversationExecution } from './hooks';
import { PopupModal } from 'components/PopupModal';

export const CsatSurveyDrawer = () => {
  const csatConfig = useAppSelector(selectCsatConfigRevamped);
  const csatStates = useAppSelector(selectCsatStates);
  const featureFlags = useAppSelector(selectFeatureFlags);

  const continueConversationExecution = useContinueConversationExecution();
  const isCsatConfigRevampEnabled = featureFlags.includes('csat_config_revamp');

  const { hasSubmitted, isCsatVisible, isEditing } = csatStates;
  const open = !!csatConfig && isCsatConfigRevampEnabled && isCsatVisible;

  if (!open) {
    return null;
  }

  return (
    <PopupModal
      onClickAway={continueConversationExecution}
      open={open}
      position='bottom'
    >
      {hasSubmitted && !isEditing ? (
        <CsatSurveySubmitted />
      ) : (
        <CsatSurveyContent />
      )}
    </PopupModal>
  );
};
